import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Legend,
    Tooltip
} from 'recharts';

interface StrainTypeData {
    name: string;
    value: number;
}

interface StrainTypeChartProps {
    data: StrainTypeData[];
}

const COLORS = {
    indica: '#8B5CF6',
    sativa: '#10B981',
    hybrid: '#3B82F6',
    unknown: '#9CA3AF',
};

export default function StrainTypeChart({ data }: StrainTypeChartProps) {
    return (
        <div className="h-[250px] w-full">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {data.map((entry) => (
                            <Cell
                                key={entry.name}
                                fill={COLORS[entry.name.toLowerCase() as keyof typeof COLORS] || COLORS.unknown}
                            />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#1F2937',
                            border: '1px solid #374151',
                            borderRadius: '8px'
                        }}
                        itemStyle={{ color: '#F3F4F6' }}
                    />
                    <Legend
                        verticalAlign="bottom"
                        height={36}
                        formatter={(value) => <span className="capitalize text-sm text-dark-muted">{value}</span>}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}
